/**
 * State availability for local (LifeX / Iron Health) plans.
 *
 * Fail-CLOSED for declared footprints: a plan that declares where it is sold
 * (non-empty `availableStates`) is hidden when the client's state can't be
 * resolved — we must not quote a narrowly-licensed plan (e.g. an NE-only plan)
 * in a state where it isn't offered. A plan with no declared footprint
 * (nationwide by design, e.g. current LifeX) is always shown.
 */

/** @returns {boolean} whether `plan` should be shown for `state` (2-letter code, or falsy if unresolved). */
export function isAvailableInState(plan, state) {
  const footprint = plan && Array.isArray(plan.availableStates) ? plan.availableStates : null;
  if (!footprint || footprint.length === 0) return true;   // no declared footprint -> nationwide by design
  if (!state) return false;                                // footprint declared but state unknown -> can't verify -> hide
  return footprint.includes(state);
}

/**
 * Filter plans by resolved state.
 * @param {Array} plans
 * @param {string} state - Two-letter state code (e.g. 'FL'), or falsy if unresolved
 * @returns {Array} Filtered plans
 */
export function filterByState(plans, state) {
  return (plans || []).filter((p) => isAvailableInState(p, state));
}
